import React from "react";

const WalkInOpenSvg = (props) => (
  <svg
    style={{ margin: "0px", padding: "0px", height: "90px", width: "200px" }}
  >
    <svg
      height="200px"
      width="auto"
      id="ICONS"
      version="1.1"
      viewBox="0 0 128 128"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <rect
          x="2"
          y="2"
          width="105"
          height="50"
          fill="none"
          stroke={props.rectColor}
          stroke-width="1"
        ></rect>
        <text
          x="4"
          y="10"
          font-family="Verdana"
          font-size="6"
          font-weight="normal"
          fill={props.textColor}
        >
          {props.name}
        </text>
      </g>
      <g
        fill="none"
        fill-rule="evenodd"
        id="Snow"
        stroke="none"
        stroke-width="1"
      >
        <g
          id="Group"
          stroke={props.strokeColor1}
          transform="translate(7.000000, 15.000000)"
        >
          <g>
            <path
              d="M9.28571429,0.928571429 L13,3.71428571 L16.7142857,0.928571429 M25.0714286,9.28571429 L22.2857143,13 L25.0714286,16.7142857 M16.7142857,25.0714286 L13,22.2857143 L9.28571429,25.0714286 M0.928571429,16.7142857 L3.71428571,13 L0.928571429,9.28571429"
              id="Path-12"
              stroke-linecap="round"
              stroke-width="2"
            />
            <circle cx="13" cy="13" fill="#979797" id="Oval-9" r="1.85714286" />
            <path
              d="M13,0 L13,26"
              id="Path-13"
              stroke-linecap="round"
              stroke-width="2"
            />
            <path
              d="M0,13 L26,13"
              id="Path-14"
              stroke-linecap="round"
              stroke-width="2"
            />
            <path
              d="M3.71428571,3.71428571 L22.2857143,22.2857143"
              id="Path-16"
              stroke-linecap="round"
              stroke-width="2"
            />
            <path
              d="M3.71428571,22.2857143 L22.2857143,3.71428571"
              id="Path-17"
              stroke-linecap="round"
              stroke-width="2"
            />
          </g>
        </g>
      </g>
    </svg>
    <svg
      height="auto"
      version="1.1"
      viewBox="0 0 60 60"
      width="300px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title />
      <desc />
      <defs />
      <g
        fill="none"
        fill-rule="evenodd"
        id="Thermometer-Hot"
        stroke="none"
        stroke-width="1"
        transform="translate(-33,13)"
      >
        <g
          id="Group"
          stroke="#979797"
          stroke-width="2"
          transform="translate(7.000000, 2.000000)"
        >
          <path
            d="M3,16.8026932 L3,3 C3,1.34314575 4.34314575,3.04359188e-16 6,0 C7.65685425,-3.04359188e-16 9,1.34314575 9,3 L9,16.8026932 C10.7934041,17.8401214 12,19.7791529 12,22 C12,25.3137085 9.3137085,28 6,28 C2.6862915,28 0,25.3137085 0,22 C0,19.7791529 1.20659589,17.8401214 3,16.8026932 Z"
            id="Combined-Shape"
          />
          <path d="M13,5 L18,5" id="Path-19" stroke-linecap="round" />
          <path d="M13,9 L18,9" id="Path-20" stroke-linecap="round" />
          <path d="M13,13 L18,13" id="Path-21" stroke-linecap="round" />
        </g>
        <g fill="red" id="Group-2" transform="translate(10.000000, 12.000000)">
          <circle cx="3" cy="12" id="Oval" r="3" />
          <rect height="11" id="Rectangle-2" rx="1" width="2" x="2" y="0" />
        </g>
      </g>
    </svg>
    <svg
      version="1.1"
      viewBox="0 0 1700 1700"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="#979797"
        stroke-width="2"
        transform="translate(900,350)"
        fill="red"
      >
        <path d="M735.5,150.8c0,6.7,0,13.4,0,20.1c0,18.1,0,36.3,0,54.4c0,26.9,0,53.9,0,80.8c0,32.9,0,65.7,0,98.6     c0,35.8,0,71.7,0,107.5c0,36.3,0,72.7,0,109c0,33.7,0,67.5,0,101.2c0,28.6,0,57.3,0,85.9c0,20.6,0,41.2,0,61.8     c0,9.7-0.1,19.4,0,29.2c0,0.4,0,0.8,0,1.3c13.3-13.3,26.7-26.7,40-40c-21.7,0-43.5,0-65.2,0c-34.4,0-68.9,0-103.3,0     c-7.9,0-15.8,0-23.8,0c13.3,13.3,26.7,26.7,40,40c0-6.9,0-13.9,0-20.8c0-18.8,0-37.6,0-56.4c0-27.9,0-55.8,0-83.7     c0-34.1,0-68.1,0-102.2c0-37.1,0-74.3,0-111.4c0-37.7,0-75.3,0-113c0-35.1,0-70.2,0-105.3c0-29.5,0-59.1,0-88.6     c0-21.3,0-42.7,0-64c0-10.1,0.2-20.2,0-30.2c0-0.4,0-0.9,0-1.3c-13.3,13.3-26.7,26.7-40,40c48.9,0,97.8,0,146.7,0     c7.5,0,15.3-0.6,22.7,0.3c-3.5-0.5-7.1-1-10.6-1.4c2.2,0.4,4.3,1,6.4,1.8c-3.2-1.3-6.4-2.7-9.6-4c2,0.9,3.8,2,5.6,3.3     c-2.7-2.1-5.4-4.2-8.1-6.3c1.7,1.4,3.2,2.8,4.7,4.5c-2.1-2.7-4.2-5.4-6.3-8.1c1.6,2.1,2.9,4.3,4,6.7c-1.3-3.2-2.7-6.4-4-9.6     c0.8,2.1,1.4,4.2,1.8,6.4c-0.5-3.5-1-7.1-1.4-10.6C735.3,148,735.4,149.4,735.5,150.8c0.3,10.4,4.3,20.9,11.7,28.3     c6.9,6.9,18.3,12.2,28.3,11.7c21.2-1,40.6-17.6,40-40c-0.6-24.2-13.6-49-36.2-59.6c-10.7-5-21.4-7.6-33.2-7.6     c-10.9,0-21.8,0-32.7,0c-34.6,0-69.2,0-103.8,0c-8.8,0-17.6,0-26.4,0c-21.6,0-40,18.3-40,40c0,6.9,0,13.9,0,20.8     c0,18.8,0,37.6,0,56.4c0,27.9,0,55.8,0,83.7c0,34.1,0,68.1,0,102.2c0,37.1,0,74.3,0,111.4c0,37.7,0,75.3,0,113     c0,35.1,0,70.2,0,105.3c0,29.5,0,59.1,0,88.6c0,21.3,0,42.7,0,64c0,10.1-0.1,20.2,0,30.2c0,0.4,0,0.9,0,1.3c0,21.6,18.3,40,40,40     c21.7,0,43.5,0,65.2,0c34.4,0,68.9,0,103.3,0c7.9,0,15.8,0,23.8,0c21.6,0,40-18.3,40-40c0-6.7,0-13.4,0-20.1     c0-18.1,0-36.3,0-54.4c0-26.9,0-53.9,0-80.8c0-32.9,0-65.7,0-98.6c0-35.8,0-71.7,0-107.5c0-36.3,0-72.7,0-109     c0-33.7,0-67.5,0-101.2c0-28.6,0-57.3,0-85.9c0-20.6,0-41.2,0-61.8c0-9.7,0.1-19.4,0-29.2c0-0.4,0-0.8,0-1.3     c0-20.9-18.4-41-40-40C753.8,111.8,735.5,128.4,735.5,150.8z" />
        <path d="M775.5,940.5c31.7,0,63.4,0,95.1,0c4.5,0,9,0,13.6,0c20.9,0,41-18.4,40-40c-1-21.7-17.6-40-40-40     c-31.7,0-63.4,0-95.1,0c-4.5,0-9,0-13.6,0c-20.9,0-41,18.4-40,40C736.4,922.2,753,940.5,775.5,940.5L775.5,940.5z" />
        <path d="M417.1,512c0.7,30.4,19.5,59.3,52.3,60.4c32.2,1,52.4-31.5,52.3-60.4c-0.1-29.6-20.1-60.4-52.3-60.4     C436.6,451.6,417.9,482.4,417.1,512c-0.5,20.9,18.8,41,40,40c22.1-1,39.5-17.6,40-40c0-1.7,0.2-3.3,0.4-4.9     c-0.5,3.5-1,7.1-1.4,10.6c0.4-2.5,1.1-4.8,2-7.1c-1.3,3.2-2.7,6.4-4,9.6c0.8-1.6,1.6-3,2.7-4.4c-2.1,2.7-4.2,5.4-6.3,8.1     c0.8-0.9,1.5-1.6,2.5-2.3c-2.7,2.1-5.4,4.2-8.1,6.3c0.6-0.4,1.2-0.7,1.8-1c-3.2,1.3-6.4,2.7-9.6,4c0.6-0.3,1.3-0.4,2-0.5     c-3.5,0.5-7.1,1-10.6,1.4c0.7-0.1,1.3-0.1,2,0c-3.5-0.5-7.1-1-10.6-1.4c0.7,0.1,1.3,0.3,2,0.5c-3.2-1.3-6.4-2.7-9.6-4     c0.6,0.3,1.3,0.6,1.8,1c-2.7-2.1-5.4-4.2-8.1-6.3c0.9,0.7,1.7,1.4,2.5,2.3c-2.1-2.7-4.2-5.4-6.3-8.1c1.1,1.4,1.9,2.8,2.7,4.4     c-1.3-3.2-2.7-6.4-4-9.6c1,2.3,1.6,4.7,2,7.1c-0.5-3.5-1-7.1-1.4-10.6c0.4,3.3,0.4,6.5,0,9.8c0.5-3.5,1-7.1,1.4-10.6     c-0.4,2.5-1.1,4.8-2,7.1c1.3-3.2,2.7-6.4,4-9.6c-0.8,1.6-1.6,3-2.7,4.4c2.1-2.7,4.2-5.4,6.3-8.1c-0.8,0.9-1.5,1.6-2.5,2.3     c2.7-2.1,5.4-4.2,8.1-6.3c-0.6,0.4-1.2,0.7-1.8,1c3.2-1.3,6.4-2.7,9.6-4c-0.6,0.3-1.3,0.4-2,0.5c3.5-0.5,7.1-1,10.6-1.4     c-0.7,0.1-1.3,0.1-2,0c3.5,0.5,7.1,1,10.6,1.4c-0.7-0.1-1.3-0.3-2-0.5c3.2,1.3,6.4,2.7,9.6,4c-0.6-0.3-1.3-0.6-1.8-1     c2.7,2.1,5.4,4.2,8.1,6.3c-0.9-0.7-1.7-1.4-2.5-2.3c2.1,2.7,4.2,5.4,6.3,8.1c-1.1-1.4-1.9-2.8-2.7-4.4c1.3,3.2,2.7,6.4,4,9.6     c-1-2.3-1.6-4.7-2-7.1c0.5,3.5,1,7.1,1.4,10.6c-0.2-1.6-0.3-3.2-0.4-4.9c-0.3-10.4-4.3-20.9-11.7-28.3     c-6.9-6.9-18.3-12.2-28.3-11.7C435.9,473,416.6,489.6,417.1,512z" />
        <path d="M543.2,93.1c0,7.7,0,15.5,0,23.2c0,21,0,41.9,0,62.9c0,31,0,61.9,0,92.9c0,37.9,0,75.9,0,113.8     c0,41.4,0,82.8,0,124.2c0,41.8,0,83.6,0,125.4c0,39.1,0,78.3,0,117.4c0,33.1,0,66.1,0,99.2c0,23.7,0,47.3,0,71     c0,11.2-0.1,22.4,0,33.7c0,0.5,0,1,0,1.5c16.9-12.9,33.8-25.7,50.6-38.6c-37.7-6.5-75.4-13-113.1-19.5     c-60.1-10.4-120.2-20.7-180.2-31.1c-13.8-2.4-27.6-4.7-41.3-7.1c9.8,12.9,19.6,25.7,29.4,38.6c0-6.7,0-13.4,0-20.1     c0-18.2,0-36.5,0-54.7c0-27.1,0-54.2,0-81.3c0-32.9,0-65.8,0-98.7c0-36,0-72,0-108c0-36.3,0-72.6,0-109c0-34,0-67.9,0-101.9     c0-28.5,0-57,0-85.5c0-20.4,0-40.8,0-61.1c0-9.5-0.1-18.9,0-28.4c0-1.7,0.1-3.4,0.3-5.1c-0.5,3.5-1,7.1-1.4,10.6     c0.4-2.2,1-4.3,1.8-6.4c-1.3,3.2-2.7,6.4-4,9.6c1.1-2.4,2.4-4.6,4-6.7c-2.1,2.7-4.2,5.4-6.3,8.1c1.4-1.7,2.9-3.1,4.7-4.5     c-2.7,2.1-5.4,4.2-8.1,6.3c1.8-1.3,3.6-2.4,5.6-3.3c-3.2,1.3-6.4,2.7-9.6,4c2.1-0.8,4.2-1.4,6.4-1.8c-3.5,0.5-7.1,1-10.6,1.4     c36.2-4.7,71.9-13.5,107.6-20.8c50.9-10.5,101.8-20.9,152.7-31.4c11.8-2.4,23.5-4.8,35.3-7.2c-3.5,0.5-7.1,1-10.6,1.4     c1.4,0,2.7,0.1,4.1,0.3c-3.5-0.5-7.1-1-10.6-1.4c2.2,0.4,4.3,1,6.4,1.8c-3.2-1.3-6.4-2.7-9.6-4c2,0.9,3.8,2,5.6,3.3     c-2.7-2.1-5.4-4.2-8.1-6.3c1.7,1.4,3.2,2.8,4.7,4.5c-2.1-2.7-4.2-5.4-6.3-8.1c1.6,2.1,2.9,4.3,4,6.7c-1.3-3.2-2.7-6.4-4-9.6     c0.8,2.1,1.4,4.2,1.8,6.4c-0.5-3.5-1-7.1-1.4-10.6C543.1,90.4,543.2,91.7,543.2,93.1c0.3,10.4,4.3,20.9,11.7,28.3     c6.9,6.9,18.3,12.2,28.3,11.7c21.2-1,40.6-17.6,40-40c-0.6-23.4-11.6-43.1-30.6-56.4c-13.6-9.5-31.1-12.5-47.2-9.4     c-3.8,0.7-7.7,1.6-11.5,2.4c-20.8,4.3-41.5,8.5-62.3,12.8c-55.5,11.4-111,22.8-166.4,34.2c-13.5,2.8-27,5.5-40.5,8.3     c3.5-0.5,7.1-1,10.6-1.4c-37.2,1-66.6,30.6-66.9,67.9c0,3,0,6,0,9c0,15.6,0,31.1,0,46.7c0,25.7,0,51.4,0,77.1     c0,32.8,0,65.5,0,98.3c0,36.7,0,73.5,0,110.2c0,37.6,0,75.2,0,112.9c0,35.4,0,70.9,0,106.3c0,30.2,0,60.4,0,90.5     c0,21.9,0,43.8,0,65.7c0,10.3-0.2,20.7,0,31c0,0.5,0,0.9,0,1.4c0,8.9,3.2,17.3,8.6,24.2c4.9,6.3,12.6,12.9,20.8,14.3     c37.7,6.5,75.4,13,113.1,19.5c60.1,10.4,120.2,20.7,180.2,31.1c13.8,2.4,27.6,4.7,41.3,7.1c13,2.2,24.2,1.1,34.9-7.2     c9.9-7.6,15.8-18.7,15.8-31.4c0-7.7,0-15.5,0-23.2c0-21,0-41.9,0-62.9c0-31,0-61.9,0-92.9c0-37.9,0-75.9,0-113.8     c0-41.4,0-82.8,0-124.2c0-41.8,0-83.6,0-125.4c0-39.1,0-78.3,0-117.4c0-33.1,0-66.1,0-99.2c0-23.7,0-47.3,0-71     c0-11.2,0.1-22.4,0-33.7c0-0.5,0-1,0-1.5c0-20.9-18.4-41-40-40C561.5,54.1,543.2,70.7,543.2,93.1z" />
        <path d="M139.9,940.5c31.7,0,63.4,0,95.1,0c4.5,0,9,0,13.6,0c20.9,0,41-18.4,40-40c-1-21.7-17.6-40-40-40     c-31.7,0-63.4,0-95.1,0c-4.5,0-9,0-13.6,0c-20.9,0-41,18.4-40,40C100.9,922.2,117.5,940.5,139.9,940.5L139.9,940.5z" />
      </g>
    </svg>
  </svg>
);
export default WalkInOpenSvg;
